import React from "react";
import { Button } from "@mui/material";
import { useMutation } from "react-query";
import { useDataProvider, useNotify } from "react-admin";

const TouchMessageButton = ({ messageId }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const { mutate, isLoading } = useMutation(
    ["touchMessage", messageId],
    () => dataProvider.touchMessage({ id: messageId }),
    {
      onSuccess: () => notify("Message touched", { type: "success" }),
      onError: (error) =>
        notify(`Touch failed: ${error?.message || "unknown error"}`, { type: "error" }),
    }
  );

  const handleClick = () => {
    const userConfirmed = window.confirm(
      "Touch this message? Clients will resync it."
    );
    if (userConfirmed) {
      mutate();
    }
  };

  return (
    <Button onClick={handleClick} disabled={isLoading}>
      Touch
    </Button>
  );
};

export default TouchMessageButton;
